<div class="dialog-wrapper">
  <!-- Header -->
  <div class="dialog-header">
    <button class="close-btn" (click)="onClose()" type="button">
      <span>&times;</span>
    </button>
    <h2 class="dialog-title">Use CashBack</h2>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <!-- CashBack Value -->
    <div class="form-group">
      <label class="form-label" for="cashbackValue">CashBack Value</label>
      <input
        type="number"
        id="cashbackValue"
        class="form-input"
        [(ngModel)]="cashbackValue"
        name="cashbackValue"
        placeholder="1"
      />
    </div>

    <!-- CashBack Note -->
    <div class="form-group">
      <label class="form-label" for="cashbackNote">CashBack Note</label>
      <textarea
        id="cashbackNote"
        class="form-textarea"
        [(ngModel)]="cashbackNote"
        name="cashbackNote"
        rows="4"
        placeholder=""
      ></textarea>
    </div>
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button class="btn btn-close" (click)="onClose()" type="button">
      Close
    </button>
    <button class="btn btn-submit" (click)="onSubmit()" type="button">
      Submit
    </button>
  </div>
</div>
